import { Injectable, inject } from '@angular/core';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {Notification} from './notification';
import {NotificationComponent} from './notification.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private snackBar = inject(MatSnackBar);

  showSuccess(message: string): void {
    this.showNotification({level: 'success', message});
  }

  showInfo(message: string): void {
    this.showNotification({level: 'info', message});
  }

  showWarning(message: string): void {
    this.showNotification({level: 'warn', message});
  }

  showError(message: string): void {
    this.showNotification({level: 'error', message});
  }

  showNotification(notification: Notification): void {
    const config: MatSnackBarConfig<Notification> = {
      data: notification,
      duration: 20000,
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
    };
    this.snackBar.openFromComponent(NotificationComponent, config);
  }
}
